import { useCallback, useEffect, useRef, useState } from 'react';
function useKeyNavigation(ref, startIndex = -1, collectionLength, scrollOffset = 50, focusable = true) {
    const [selection, setSelection] = useState(startIndex);
    const listRef = useRef(null);
    const handleKey = useCallback((e) => {
        const key = e.key;
        if ((key === 'ArrowUp' || key === 'ArrowDown') && focusable) {
            const _listRef = listRef.current;
            e.preventDefault();
            if (key === 'ArrowDown') {
                setSelection(prev => {
                    if (prev < collectionLength - 1) {
                        return prev + 1;
                    }
                    else {
                        return 0;
                    }
                });
                // scroll to top
                if (_listRef) {
                    _listRef.scrollTop += scrollOffset;
                }
            }
            else if (key === 'ArrowUp') {
                setSelection(prev => {
                    if (prev > 0) {
                        return prev - 1;
                    }
                    else {
                        return collectionLength - 1;
                    }
                });
                if (_listRef) {
                    _listRef.scrollTop -= scrollOffset;
                }
            }
        }
    }, [selection, collectionLength]);
    useEffect(() => {
        if (ref && focusable) {
            listRef.current = ref.current;
            listRef.current?.addEventListener('keydown', handleKey);
        }
    }, [ref]);
    useEffect(() => {
        return () => {
            if (listRef && focusable) {
                listRef.current?.removeEventListener('keydown', handleKey);
            }
        };
    }, []);
    return { selection, setSelection };
}
export { useKeyNavigation };
